import React from 'react';
import { Sparkle } from './Sparkle';
import { CtaButton } from './CtaButton';
import { checkoutUrl, price, valueStack } from '../data/content';
type OfferCardProps = {
  id?: string;
};
export function OfferCard({
  id
}: OfferCardProps) {
  return <section id={id} aria-label="Oferta" className="scroll-mt-20 bg-kraft px-4 py-10 sm:px-5 sm:py-16 lg:py-24" data-id="element-104" data-mp="rhgkp2y5cvj2">
      <div className="mx-auto max-w-2xl rounded-3xl border-2 border-ink bg-cream p-5 shadow-[5px_5px_0_0_#141210] sm:p-10 sm:shadow-[8px_8px_0_0_#141210]" data-id="element-105" data-mp="mkgems1arsry">
        <div className="flex items-center justify-center gap-3" data-id="element-106" data-mp="1f7u7adxyq269">
          <Sparkle className="h-5 w-5" data-id="element-107" data-mp="1afswkwgg0jic" />
          <h2 className="font-display text-xl font-black uppercase tracking-tight sm:text-3xl" data-id="element-108" data-mp="1aergueohf8ua">Lo que te llevas hoy</h2>
          <Sparkle className="h-5 w-5" data-id="element-109" data-mp="15gprxd4dkfaw" />
        </div>

        <ul className="mt-5 text-sm sm:mt-8 sm:text-base" data-id="element-110" data-mp="22wlokaa0l049">
          {valueStack.map(v => <li key={v.item} className="flex items-baseline gap-2 py-2.5" data-id="element-111" data-mp="1y5wxux65s766">
              <span className="font-medium" data-id="element-112" data-mp="1y3sjflamvprn">{v.item}</span>
              <span aria-hidden="true" className="flex-1 border-b-2 border-dotted border-kraft-dark/50" data-id="element-113" data-mp="8h47ipkl0zkz" />
              <span className="whitespace-nowrap font-display font-bold text-ink-soft" data-id="element-114" data-mp="dee6owxrwpm0">{v.value}</span>
            </li>)}
        </ul>

        <div className="mt-6 flex items-baseline justify-between border-t-2 border-ink pt-4" data-id="element-115" data-mp="3vr2jrp4threp">
          <span className="font-medium" data-id="element-116" data-mp="3mq9efejcecm">Todo tiene un valor de</span>
          <s className="font-display text-2xl font-black text-ink-soft" data-id="element-117" data-mp="3lt4ls9x5og8w">{price.total}</s>
        </div>

        <div className="mt-6 text-center sm:mt-8" data-id="element-118" data-mp="3qvdgpbtl9sdn">
          <p className="font-display text-sm font-extrabold uppercase tracking-widest text-rust-dark" data-id="element-119" data-mp="3cuatuwurse1o">Solo hoy</p>
          <p className="font-display text-6xl font-black leading-none tracking-tight sm:text-8xl" data-id="element-120" data-mp="3guuqlzbflfna">{price.today}</p>
          <p className="mt-2 text-sm text-ink-soft" data-id="element-121" data-mp="1b3pjrgekrzuu">Pago único · Acceso inmediato</p>
        </div>

        <div className="mt-6 sm:mt-8" data-id="element-122" data-mp="1f384ab2hi8x5">
          <CtaButton label="¡Sí, quiero mi diario ahora!" href={checkoutUrl} align="center" showNote data-id="element-123" data-mp="1f25e65czkaia" />
        </div>
      </div>
    </section>;
}